module.exports = __webpack_public_path__ + "static/logo-77387599a98a90ea35aec51e46d1a84a.svg";